import { Loader } from '@ubeya/shared-web/components';
import { EmptyState } from '../EmptyState';

export const GRID_STATIC_OPTIONS = {
  rowHeight: 50,
  animateRows: true,
  maintainColumnOrder: true,
  rowDragManaged: false,
  suppressDragLeaveHidesColumns: true,
  suppressContextMenu: true,
  tooltipShowDelay: 0,
  suppressGroupChangesColumnVisibility: 'suppressHideOnGroup',
  suppressAggFuncInHeader: true,
  groupHeaderHeight: 0,
  groupDefaultExpanded: 0,
  stopEditingWhenCellsLoseFocus: true,
  suppressGroupRowsSticky: true,
  noRowsOverlayComponent: EmptyState,
  loadingOverlayComponent: Loader
};

export const GROUP_BY_TO_FIELD_MAP = {
  employee: 'employeeId',
  date: 'date',
  position: 'position',
  project: 'projectId',
  client: 'clientId',
  costCenter: 'costCenter',
  noGroupBy: 'noGroupBy',
  positionName: 'positionName',
  effectiveDate: 'effectiveDate',
  supplierAccountName: 'supplierAccountName',
  clientAccountName: 'clientAccountName',
  'payRate.hourlyWage': 'payRate.hourlyWage',
  'billRate.hourlyWage': 'billRate.hourlyWage'
};

export const actionColumnStaticOptions = (isRtl) => ({
  headerName: '',
  field: 'actions',
  width: 50,
  minWidth: 50,
  cellClass: 'grid-cell-actions',
  pinned: isRtl ? 'left' : 'right',
  sortable: false,
  resizable: false,
  suppressHeaderMenuButton: true,
  suppressMovable: true,
  suppressColumnsToolPanel: true
});
